import React, { useRef } from "react";
import { rateSetModel } from "../rateSetModel";
import { YHDrawer } from "@components/YhDrawer";
import {
  FormItemTypeEnum,
  IYhForm,
  IYhFormRef,
} from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { GenderDs } from "@src/types/FmsDs";
import { EditableCell, EditableRow } from "@components/YHEditTable/editTable";
import moment from "moment";
import { message, Modal, Table } from "antd";
import { useLockFn } from "ahooks";
import { useState } from "react";
import { ColumnsType } from "antd/lib/table";
import { IMdUserDetail, IRateItem } from "../rateSetTypes";
import { rateSetService } from "../rateSetService";
import { globalPrompt } from "@src/components/YhMessage";
import { useEffect } from "react";
import { YhBut } from "@src/components/YhButton";

const initData = () => ({
  id: new Date().getTime() + Math.floor(Math.random() * 10000),
  name: "请输入后回车添加",
  addNewRow: true,
});

export function DetailDrawer() {
  const {
    drawerVisible,
    setDrawerVisible,
    selectedRow,
    editType,
    loadData,
    appDs,
  } = rateSetModel();

  const onCancel = () => {
    setDrawerVisible(false);
  };

  useEffect(() => {
    // const {appName, appCode, name, indicatorList} = selectedRow as IMdUserDetail
    if (editType === "add") {
      formRef.current?.setFieldsValue({
        appName: "",
        appCode: "",
        name: "",
        code: "",
      });
      setDataSource([initData()]);
    } else {
      formRef.current?.setFieldsValue({
        appName: selectedRow?.appName,
        appCode: selectedRow?.appCode,
        name: selectedRow?.name,
        code: selectedRow?.code,
      });
      setDataSource(
        selectedRow?.indicatorList && selectedRow?.indicatorList.length > 0
          ? selectedRow?.indicatorList.concat(initData())
          : [initData()]
      );
    }
  }, [drawerVisible]);

  const formRef = useRef<IYhFormRef>();

  const [dataSource, setDataSource] = useState<IRateItem[]>([initData()]);
  const columns = [
    {
      align: "center",
      title: "序号",
      width: 20,
      render: (v: any, r: any, i: any) => i + 1,
    },
    {
      align: "center",
      title: "名称",
      width: 50,
      dataIndex: "name",
      editable: true,
      onInputEnter(e: any, r: any) {
        if (!r.addNewRow) {
          return;
        } else {
          const newData = [...dataSource];
          const index = newData.findIndex((item) => r.id === item.id);
          const item = newData[index];
          newData.splice(index, 1, { ...item, ...r, addNewRow: false });
          setDataSource(newData.concat(initData()));
        }
      },
      render: (v: any, r: any, i: any) => <span style={{lineHeight: '28px'}}>{v}</span>,
    },
    {
      align: "left",
      title: "描述",
      width: 150,
      dataIndex: "desc",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{lineHeight: '28px'}}>{v}</span>,
    },
    {
      align: "center",
      title: '操作',
      width: 20,
      dataIndex: 'enable',
      fixed: "right",
      render: (value: string, r: any) => {
          return (
              <>
                {
                    !r.addNewRow && <YhBut
                    typeName="icon-shanchu"
                    text="删除"
                    style={{ color: "#028E19", fontSize: "18px" }}
                    click={() => {handelDelete(r)}}
                />
                }
              </>
          )
      }
  },
  ];

  const handelDelete = (item:any) => {
    Modal.confirm({
      title: '删除',
      centered: true,
      closable: true,
      content: (<div>确定要删除--{item.name}</div>),
      onOk(){
          let list = [...dataSource]
          setDataSource(list.filter(i => i.id !== item.id))
      }
  })
  }

  const newSelectColumns = columns.map((col: any, index) => {
    return {
      ...col,
      onCell: (record: IRateItem, rowIndex: number) => {
        let editable = col?.editable;
        if (col.dataIndex === "name") {
          editable = true;
        } else if (col.dataIndex === "desc") {
          editable = !record.addNewRow;
        }
        return {
          colIndex: index,
          rowIndex,
          record,
          rules: col.rules,
          options: col.options,
          editType: col.editType,
          editable: editable,
          dataIndex: col.dataIndex,
          title: col.title,
          onInputEnter: col?.onInputEnter,
          handleSave: handleSave,
        };
      },
    };
  });

  const handleSave = (row: IRateItem) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];

    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const handleAppChange = (e: any) => {
    formRef.current?.setFieldsValue({
      appName: appDs.find((i) => i.value === e)?.label,
    });
  };

  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 6 },
    disabled: editType === "look",
    justify: "start",
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "编码",
        fieldName: "code",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "模版名称",
        fieldName: "name",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "系统名称",
        fieldName: "appCode",
        span: 12,
        ds: appDs,
        onChange: handleAppChange,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "系统名称",
        fieldName: "appName",
        hidden: true,
      },
    ],
  };

  const onOk = useLockFn(async () => {
    if (editType === "look") return onCancel();
    try {
      const formData = await formRef.current?.validateFields();
      let indicators: Omit<IRateItem, "id">[] = [];
      dataSource.forEach((i) => {
        const { addNewRow, name, desc } = i;
        if (!addNewRow) {
          indicators.push({ name, desc });
        }
      });
      if (formData) {
        if (editType !== "edit") {
          const insertRet = await rateSetService.insert({
            ...formData,
            indicators,
          });
          if (insertRet.success) {
            await globalPrompt("message", {
              type: "success",
              text: "新增成功!",
            });
            setDrawerVisible(false);
            loadData({ pageNum: 1 }, {});
          } else {
            await globalPrompt("message", {
              type: "error",
              text: "新增失败!" + insertRet.retMsg,
            });
          }
        } else {
          const insertRet = await rateSetService.edit({
            ...formData,
            id: selectedRow?.id,
            indicators,
          });
          if (insertRet.success) {
            await globalPrompt("message", {
              type: "success",
              text: "编辑成功!",
            });
            setDrawerVisible(false);
            loadData({ pageNum: 1 }, {});
          } else {
            await globalPrompt("message", {
              type: "error",
              text: "编辑失败!" + insertRet.retMsg,
            });
          }
        }
      }
    } catch (e) {
      console.log("失败!");
    }
  });

  return (
    <YHDrawer
      {...{
        title: "评价设置",
        visible: drawerVisible,
        onOk,
        onCancel,
        width: 800,
        showFooter: true,
        okText: "保存",
        cancelText: "取消",
      }}
    >
      {/*<DetailForm/>*/}
      <YhForm {...formConfig} />
      <Table
        style={{ marginTop: "20px" }}
        rowClassName="editable-row yh-edit-table-tr"
        rowKey={(record, index) => record.id}
        bordered
        components={{
          body: {
            row: EditableRow,
            cell: EditableCell,
          },
        }}
        columns={newSelectColumns}
        dataSource={dataSource}
        scroll={{ x: "max-content", y: "300px" }}
        pagination={false}
      />
    </YHDrawer>
  );
}
